export default __webpack_public_path__ + "static/media/supljikvadar.66cf7f7b.jpg";